import { Plus, Upload } from 'lucide-react';
import Button from '../../../components/Button';
import type { CollectionName } from '../services/learningService';

const COLLECTION_OPTIONS: { value: CollectionName; label: string }[] = [
    { value: 'learning-sections', label: 'learning-sections' },
    { value: 'learning-sections-v2', label: 'learning-sections-v2' },
];

interface LessonsPageHeaderProps {
    selectedCollection: CollectionName;
    onCollectionChange: (collection: CollectionName) => void;
    onImport: () => void;
    onNewSection: () => void;
}

const LessonsPageHeader = ({
    selectedCollection,
    onCollectionChange,
    onImport,
    onNewSection,
}: LessonsPageHeaderProps) => (
    <div className="mb-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-start">
            <div className="flex-1">
                <h1 className="text-3xl font-bold text-gray-900">Lessons</h1>
                <p className="mt-2 text-gray-600">Manage learning sections, lessons, and content</p>
            </div>
            <div className="flex flex-wrap items-center gap-3">
                <select
                    value={selectedCollection}
                    onChange={(e) => onCollectionChange(e.target.value as CollectionName)}
                    className="px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                    {COLLECTION_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
                <Button
                    onClick={onImport}
                    variant="outline"
                    icon={<Upload size={20} />}
                >
                    Import
                </Button>
                <Button
                    onClick={onNewSection}
                    variant="primary"
                    icon={<Plus size={20} />}
                >
                    New Section
                </Button>
            </div>
        </div>
    </div>
);

export default LessonsPageHeader;
